import { apiUrl } from "../utils/apiUrl";

export async function saveResult(payload) {
  const response = await fetch(apiUrl("/save-result"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`save-result failed: ${response.status}`);
  }

  return response.json();
}
